import Vue from 'vue';

import ModalProvider from '~/components/Common/ModalProvider';

let instance;

if (!window.document.getElementById('modal-container')) {
  const container = window.document.createElement('div');
  container.id = 'modal-container';
  const body = window.document.body;
  body.insertBefore(container, document.body.firstChild);
}

if (!Vue.prototype.$modal) {
  Object.defineProperty(Vue.prototype, '$vmodal', {
    get() {
      if (!instance) {
        instance = new Vue({
          parent: this.$root,
          render: (h) => h(ModalProvider, { ref: 'provider' }, []),
        });
        instance.$mount('#modal-container');
      }

      return instance.$refs.provider;
    },
  });
}
